<template>
  <div v-if="isAtLimit" class="photo-limit-warning">
    <template v-if="maxPhotos === 1">1 item can be selected for each Reel or Story</template>
    <template v-else>You've reached the limit for this post ({{ maxPhotos }} max)</template>
  </div>
</template>

<script setup lang="ts">
import { MAX_PHOTOS_PER_POST } from "@/constants/social";

withDefaults(
  defineProps<{
    isAtLimit: boolean;
    maxPhotos?: number;
  }>(),
  {
    maxPhotos: MAX_PHOTOS_PER_POST,
  }
);
</script>

<style scoped lang="scss">
.photo-limit-warning {
  width: fit-content;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  padding-right: 20px;
  background: rgba(13, 110, 253, 0.1);
  border: 1px solid rgba(13, 110, 253, 0.35);
  border-radius: 6px;
  color: #1b1c1dc7;
  font-weight: 600;
  // text-align: center;
}
</style>
